import { render, staticRenderFns } from "./LightSpeedVideoEditor.vue?vue&type=template&id=f5834106&"
import script from "./LightSpeedVideoEditor.vue?vue&type=script&lang=ts&"
export * from "./LightSpeedVideoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports